import axios from 'axios';
import {
    MDBAlert,
    MDBBtn,
    MDBCol,
    MDBContainer,
    MDBIcon,
    MDBInput,
    MDBRating,
    MDBRatingElement,
    MDBRow,
    MDBSpinner,
    MDBTextArea, MDBTypography
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { UserProfileContext } from '../../context/UserProfileProvider';
import { DomainContext, DomainProvider } from '../../context/DomainProvider';
  function Reviews({item,reviews, setReviews}) {
    const baseUrl = process.env.REACT_APP_INVENTORY_URL;
  
    const { domainId} = useContext(DomainContext);
    const { tokenLoaded,uid,userProfile} = useContext(UserProfileContext);
    const [selectValue, setSelectValue] = useState(0);
    const [name, setName] = useState(item ? '':userProfile?.firstName?.concat(' ').concat(userProfile?.lastName));
const [email, setEmail] = useState(item ? '':userProfile?.email);
const [reviewText, setReviewText] = useState('');
const [errors, setErrors] = useState({});
const [loading, setLoading] = useState(false);

const [showAlert, setShowAlert] = useState(false);
const [alertMessage, setAlertMessage] = useState('');
const [alertColor, setAlertColor] = useState('');
// Validation for name
const didFetchRef = useRef(false);
useEffect(() => {
  console.log(reviews); // This should log the updated reviews whenever they change
}, [reviews]);

const validateName = (name) => {
  if (!name?.trim()) return "Name is required!";
  return null;
};

// Validation for email
const validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  if (!email) return "Email is required!";
  if (!emailRegex.test(email)) return "Invalid email format!";
  return null;
};

// Validation for reviewText
const validateReviewText = (reviewText) => {
  if (!reviewText?.trim()) return "Review is required!";
  return null;
};
    const validateRate= (rate) => {
  if (!rate) return "Rate is required!";
  return null;
};
useEffect(() => {
    const userReview = reviews["reviewList"]?.find(review => review.uid === uid);
    if (userReview) {
        setReviewText(userReview.review);
    }
}, [reviews, uid]);
 
  const handleReviewSubmit = async (e) => {

    if (!didFetchRef.current) {
      didFetchRef.current = true;
    e.preventDefault();
setShowAlert(false);
    const nameError = validateName(name);
    const emailError = validateEmail(email);
    const reviewTextError = validateReviewText(reviewText);
     const rateError = validateRate(selectValue);
    // After your validation checks:
    if ((!tokenLoaded && nameError) || (!tokenLoaded && emailError) || reviewTextError || rateError) {
      // Set errors to state
      setErrors({
        name: nameError,
        email: emailError,
        reviewText: reviewTextError,
        rate: rateError
      });
    
      let errorMessages = '';
      if (tokenLoaded) {
        errorMessages = [reviewTextError, rateError].filter(Boolean).join(' ');
      } else {
        errorMessages = [nameError, emailError, reviewTextError, rateError].filter(Boolean).join(' ');
        
      }
      
      setAlertMessage(errorMessages);
      setShowAlert(true);
      setAlertColor("danger");
    
      return; 
    }
    
    const reviewData = {
      name: name,
      email: email,
      id: item?.id || domainId ,
      type: item ? null : 'testimonial',
      writeUp: reviewText,
      rate: selectValue,
      firm:localStorage.getItem('FIRM'),
      domain:localStorage.getItem('DOMAIN'),
    };
  
    try {
      setLoading(true);
      const url = tokenLoaded?`${baseUrl}/reviews`:`${baseUrl}/reviews/anonymous`
      const response = await axios.post(url, reviewData);
  
     setReviews(response.data); 
    } catch (error) {
      console.error("Error submitting review:", error);
    }
    setLoading(false);
    setErrors({});
  }
  }
  

  return (
    <MDBContainer className="text-center">
     {item && <p className="my-4"><strong>{reviews.length} reviews for <em>{item?.name}</em></strong></p>}

      <MDBRow >
      {reviews["reviewList"]?.length>0  &&   <MDBCol  className="mb-2">
          {reviews["reviewList"]?.map((review, index) => (
            <div key={index} className="shadow-4 p-4 rounded-5 mb-5">
        {(review.avatarImage)  ?    <img
                className="shadow-1-strong rounded mb-3"
                style={{ width: '40px' }}
                src={review.avatarImage}
                alt="Sample"
              /> : <img
              className="shadow-1-strong rounded mb-3"
              style={{ width: '40px' }}
              src='https://opengrit.com/images/avatar'
              alt="Sample"
            />}
              <p className="mb-3 fw-bold">{review.name}</p>
              <MDBRating className="justify-content-center" value={review.rate}>
      <MDBRatingElement itemId={1} icon='star' />
      <MDBRatingElement itemId={2} icon='star' />
      <MDBRatingElement itemId={3} icon='star' />
      <MDBRatingElement itemId={4} icon='star' />
      <MDBRatingElement itemId={5} icon='star' />
    </MDBRating>
              <p className="mb-0  word-wrap">
                <MDBIcon className="fas fa-quote-left pe-2 " />{review.writeUp}
              </p>
            </div>
          ))}
        </MDBCol>}

        <MDBCol  className="mb-2">
          <form className="d-grid gap-3 mx-auto" onSubmit={handleReviewSubmit}>
            <p>{item ? 'Rate this product': <figure className='text-center mb-0'>
      <MDBTypography blockquote>
        <p className='text-black'>Brief Testimonial

</p>
      </MDBTypography>
      <figcaption className='blockquote-footer mb-0'>
      Your feedback will help <cite className='text-dark'  title='Source Title'>make informed decisions and improve our product.</cite>
      </figcaption>
    </figure>}
    </p>
        
            <MDBRating dynamic onChange={(value) => setSelectValue(value)} className="justify-content-center">
              <MDBRatingElement size='lg' itemId={1} icon='angry' color='#673ab7' />
              <MDBRatingElement size='lg' itemId={2} icon='frown' color='#3f51b5' />
              <MDBRatingElement size='lg' itemId={3} icon='meh' color='#2196f3' />
              <MDBRatingElement size='lg' itemId={4} icon='smile' color='#03a9f4' />
              <MDBRatingElement size='lg' itemId={5} icon='grin-stars' color='#00bcd4' />
            </MDBRating>

            {!tokenLoaded && <>
              <MDBInput label="Name" id="form5Example1" type="text" value={name} onChange={(e) => setName(e.target.value)} hint={errors.name} hintcolor="danger"/>
<MDBInput label="Email address" id="form5Example2" type="email" value={email} onChange={(e) => setEmail(e.target.value)} hint={errors.email} hintcolor="danger"/>

            </>}
          <MDBTextArea  label="Your review" id="textAreaExample" className='d-flex' rows="4" value={reviewText} onChange={(e) => setReviewText(e.target.value)} hint={errors.reviewText} hintcolor="danger"/>

     
            <MDBBtn type="submit" color='black'>Submit
        {loading && <MDBSpinner  size='sm' role='output' tag='span' className='me-2' />}
        
      </MDBBtn>
            <MDBAlert open={showAlert}
                color={alertColor}
                autohide
                width={800}
                position="top-right"
                offset={50}
                delay={20000}
                appendToBody
                onClick={() => setShowAlert(false)}
            >
                <MDBIcon fas icon="window-close" />   {alertMessage}
            </MDBAlert >
          </form>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
}
  Reviews.propTypes = {
    item:PropTypes.object,
    reviews:PropTypes.array,
    setReviews:PropTypes.object,
  }
  export default Reviews;
  